/**
 * useDialog Hook
 * Convenience hook for dialog functions (showDialog, showAlert).
 * Uses dialogStore (Zustand).
 */

import { useDialogStore } from '../stores/dialogStore';
import type { DialogOptions } from '../stores/dialogStore';

interface UseDialogReturn {
  showDialog: {
    (options: DialogOptions & { destructiveText: string }): Promise<boolean | 'destructive'>;
    (options: DialogOptions): Promise<boolean>;
  };
  showAlert: (options: Omit<DialogOptions, 'cancelText'>) => Promise<boolean>;
}

export const useDialog = (): UseDialogReturn => {
  const rawShowDialog = useDialogStore((s) => s.showDialog);
  const showAlert = useDialogStore((s) => s.showAlert);
  const showDialog = rawShowDialog as UseDialogReturn['showDialog'];
  return { showDialog, showAlert };
};
